import { Injectable } from '@angular/core';
import { AppSettingService } from '../services/app-setting.service';
import { ResponseContentType, RequestOptions } from '@angular/http';
import { Observable, empty, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DocumentViewService {
constructor(public http: HttpClient) { }

downloadPDF(): Observable<any> {
 
  try {

   return null;
    // return this.http
    //   .get(AppSettingService.getDocumentData2, { responseType: 3 }).pipe(catchError(this.error))
    //   .map((res:any) => {
    //     // return res;
    //     return new Blob([res], { type: 'application/pdf' })
    //   });



  } catch (error) {
    alert('error inside downloadPDF');
  }
}



getDocumentData(type: number, id: string): Observable<any> {
  try {

   
      let params = new URLSearchParams();
      params.set('attachmentType', type.toString());
      params.set('attachmentId', id.toString());

      let options = new RequestOptions({ search: params });
      return this.http
        .get(AppSettingService.getDocumentData + "?attachmentType=" + type + "&attachmentId=" + id).pipe(catchError(this.error));
    
  } catch (error) {
  
}}

emailAttachment(model: any)//:Observable<any>
{
  try {
   // var body = JSON.stringify(model);
    return this.http
      .post(AppSettingService.emailAttachmentUri, model)
      .pipe(catchError(this.error));;
  } catch (error) {
    throw new Error(error);
  }
}

error(error: HttpErrorResponse) {
  let errorMessage = '';
  if (error.error instanceof ErrorEvent) {
    errorMessage = error.error.message;
  } else {
    errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
  }
  console.log(error);
  return throwError({ error: error.error, status: error.status });
}
emailClaims(model:any){

  return this.http.post(AppSettingService.emailClaimsUri,model).pipe(catchError(this.error))
}
}
